/**
 * Default: Utils > Copy Clipboard
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

// -------
// Public
// -------

/**
 * Kopiert die aktuelle URL (inklusive aller Parameter) in die Zwischenablage.
 * Zeigt einen optionalen Konsolen-Erfolg oder Fehler an.
 * * @returns {Promise<void>} Eine Promise, die resolviert, wenn das Kopieren erfolgreich war.
 */
export const copyUrlToClipboard = async () => {
	const currentUrl = window.location.href;

	try {
		// Überprüfen, ob die Clipboard API verfügbar ist
		if (!navigator.clipboard || !navigator.clipboard.writeText)
		{
			console.error('Zwischenablage-API nicht verfügbar. Sicherstellen, dass die Seite über HTTPS ausgeliefert wird oder im localhost läuft.');

			// Fallback-Mechanismus (funktioniert meistens, ist aber älter und synchron)
			// Wäre für ein echtes Fallback nötig, wird hier aber weggelassen,
			// da die moderne API der Standard sein sollte.
			throw new Error('Clipboard API nicht gefunden.');
		}

		await navigator.clipboard.writeText(currentUrl);
		// console.log(`URL erfolgreich in die Zwischenablage kopiert: ${currentUrl}`);

	}
	catch (error) {
		console.error(`Fehler beim Kopieren der URL in die Zwischenablage: ${error.message}`, error);
		// Optional: Füge hier eine UI-Benachrichtigung für den Benutzer hinzu
	}
};